module.exports = __webpack_public_path__ + "img/lat.898d9a88.svg";